import dynamic from 'next/dynamic';

const DatePicker = dynamic(() => import('./DatePicker'), {
    ssr: false
});

export default DatePicker;
